/** Thai and English text for Drive (apps/drive): folders first, shared at the top folder, links for outsiders */
export const th = {
  app: { name: 'Drive', description: 'เก็บไฟล์ในโฟลเดอร์ของคุณ แชร์ทั้งโฟลเดอร์ให้คน สาขา แผนก หรือทั้งบริษัท และส่งลิงก์ให้คนนอก' },
  nav: { mine: 'ไดรฟ์ของฉัน', shared: 'แชร์กับฉัน', recent: 'ล่าสุด', starred: 'ติดดาว', trash: 'ถังขยะ' },
  roles: { owner: 'เจ้าของ', viewer: 'ผู้ดู', uploader: 'ผู้อัปโหลด', deleter: 'ผู้ลบ', editor: 'ผู้แก้ไข' },
  rolesHint: {
    viewer: 'เห็น เปิด และดาวน์โหลด',
    uploader: 'ทำได้แบบผู้ดู และอัปโหลด สร้างโฟลเดอร์ย่อย อัปฉบับใหม่ เปลี่ยนชื่อ ย้าย และลบของที่ตัวเองอัปโหลด',
    deleter: 'ทำได้แบบผู้ดู และลบของทุกคน (ไปถังขยะ 30 วัน) แต่อัปโหลดไม่ได้',
    editor: 'ทำได้แบบผู้อัปโหลดและผู้ลบ และเปลี่ยนชื่อ ย้ายของทุกคน',
  },
  kinds: { user: 'คน', branch: 'สาขา', department: 'แผนก', company: 'ทั้งบริษัท' },
  fileKinds: {
    pdf: 'PDF',
    excel: 'Excel',
    word: 'Word',
    powerpoint: 'PowerPoint',
    image: 'รูปภาพ',
    video: 'วิดีโอ',
    audio: 'เสียง',
    archive: 'ไฟล์บีบอัด',
    text: 'ข้อความ',
    other: 'ไฟล์',
    folder: 'โฟลเดอร์',
  },
  bytes: { b: '{{n}} B', kb: '{{n}} KB', mb: '{{n}} MB', gb: '{{n}} GB' },
  open: 'เปิด',
  uploadFolder: 'อัปโหลดโฟลเดอร์',
  sharedWithList: 'แชร์กับ{{names}}',
  and: ' และ',
  moveHere: 'ย้ายมาที่นี่',
  myRoots: 'โฟลเดอร์แรกของฉัน',
  noFolders: 'ไม่มีโฟลเดอร์ย่อย',
  viaYou: 'แชร์ให้คุณ',
  via: 'แชร์ให้{{kind}}{{name}}',
  you: 'คุณเป็น{{role}}',
  onlyYou: 'เฉพาะคุณ',
  room: 'ใช้ไป {{used}} จาก {{quota}}',
  roomTitle: 'พื้นที่ของฉัน',
  root: {
    hint: 'ไดรฟ์ของคุณมีแต่โฟลเดอร์ ไฟล์อยู่ในโฟลเดอร์เสมอ และแชร์กันที่โฟลเดอร์ชั้นนี้ ทุกอย่างข้างในใช้สิทธิ์ตามโฟลเดอร์',
    empty: 'ยังไม่มีโฟลเดอร์ สร้างโฟลเดอร์แรกเพื่อเริ่มเก็บไฟล์',
    sharedHint: 'โฟลเดอร์ที่คนอื่นแชร์ให้คุณ สาขา หรือแผนกของคุณ เปิดเข้าไปเพื่อดูไฟล์ข้างใน',
    sharedEmpty: 'ยังไม่มีใครแชร์โฟลเดอร์ให้คุณ',
  },
  columns: {
    name: 'ชื่อ',
    owner: 'เจ้าของ',
    access: 'สิทธิ์ของคุณ',
    sharedAt: 'แชร์เมื่อ',
    by: 'อัปโหลดโดย',
    updated: 'แก้ไขล่าสุด',
    size: 'ขนาด',
    where: 'อยู่ที่',
    trashed: 'ลบเมื่อ',
  },
  folder: { subfolders: 'โฟลเดอร์ย่อย', files: 'ไฟล์', empty: 'โฟลเดอร์นี้ยังว่าง ลากไฟล์มาวางหรือกดอัปโหลด', emptyView: 'โฟลเดอร์นี้ยังว่าง' },
  actions: {
    new: 'ใหม่',
    newFolder: 'โฟลเดอร์ใหม่',
    newSubfolder: 'โฟลเดอร์ย่อยใหม่',
    upload: 'อัปโหลดไฟล์',
    uploadVersion: 'อัปฉบับใหม่',
    share: 'แชร์โฟลเดอร์',
    link: 'ลิงก์คนนอก',
    preview: 'ดูตัวอย่าง',
    download: 'ดาวน์โหลด',
    rename: 'เปลี่ยนชื่อ',
    move: 'ย้าย',
    star: 'ติดดาว',
    unstar: 'เอาดาวออก',
    details: 'รายละเอียด',
    trash: 'ลบ',
    restore: 'กู้คืน',
    purge: 'ลบถาวร',
    list: 'รายการ',
    grid: 'ตาราง',
  },
  newHint: 'ไฟล์อยู่ในโฟลเดอร์เสมอ เปิดโฟลเดอร์ก่อนจึงอัปโหลดได้',
  folderName: 'ชื่อโฟลเดอร์',
  newName: 'ชื่อใหม่',
  moveTo: 'ย้ายไปที่',
  moveHint: 'ย้ายได้ภายในโฟลเดอร์แรกเดียวกัน หรือระหว่างโฟลเดอร์แรกของคุณเอง',
  share: {
    title: 'แชร์โฟลเดอร์ “{{name}}”',
    add: 'เพิ่มคน สาขา แผนก หรือทั้งบริษัท',
    people: 'ผู้มีสิทธิ์',
    remove: 'เอาสิทธิ์ออก',
    follows: 'ทุกอย่างในโฟลเดอร์นี้ใช้สิทธิ์เหล่านี้',
    inner: 'ในบริษัทเห็นตามโฟลเดอร์ “{{name}}”',
    setAtTop: 'ตั้งสิทธิ์ที่โฟลเดอร์',
    saved: 'บันทึกสิทธิ์แล้ว',
  },
  link: {
    title: 'ลิงก์คนนอกของ “{{name}}”',
    label: 'ลิงก์สำหรับคนนอก',
    hint: 'คนที่มีลิงก์เปิดได้โดยไม่ต้องมีบัญชี จนถึงวันหมดอายุ',
    expires: 'หมดอายุ',
    days: '{{days}} วัน ({{date}})',
    download: 'ดาวน์โหลดได้',
    copy: 'คัดลอกลิงก์',
    copied: 'คัดลอกลิงก์แล้ว',
    make: 'สร้างลิงก์',
    revoke: 'ยกเลิกลิงก์',
    ownerOnly: 'เฉพาะเจ้าของโฟลเดอร์ที่ทำลิงก์คนนอกได้',
  },
  details: {
    kind: 'ประเภท',
    size: 'ขนาด',
    where: 'อยู่ที่',
    by: 'อัปโหลดโดย',
    updated: 'แก้ไขล่าสุด',
    updatedBy: '{{date}} โดย {{name}}',
    access: 'ผู้มีสิทธิ์เข้าถึง',
    versions: 'ฉบับ',
    current: 'ฉบับปัจจุบัน',
    version: 'ฉบับที่ {{number}}',
    folder: 'โฟลเดอร์',
  },
  upload: {
    title: 'กำลังอัปโหลด {{count}} ไฟล์',
    done: 'อัปโหลดแล้ว {{count}} ไฟล์',
    finished: 'เสร็จแล้ว',
    failed: 'ไม่สำเร็จ',
    retry: 'ลองใหม่',
    drop: 'วางไฟล์เพื่ออัปโหลดไปที่ “{{name}}”',
    tooLarge: 'ไฟล์ใหญ่เกิน 2 GB',
  },
  trash: {
    hint: 'ของในถังขยะจะถูกลบถาวรเมื่อครบ 30 วัน',
    empty: 'ถังขยะว่าง',
    purgeConfirm: 'ลบ “{{name}}” ถาวร? กู้คืนไม่ได้อีก',
    trashed: 'ย้ายไปถังขยะแล้ว',
  },
  recent: { empty: 'ยังไม่มีไฟล์ที่แก้ไขล่าสุด' },
  starred: { empty: 'ยังไม่มีรายการที่ติดดาว' },
  preview: {
    download: 'ไฟล์นี้ดูในเว็บไม่ได้ ดาวน์โหลดเพื่อเปิดในเครื่อง',
    page: 'หน้า {{page}} / {{pages}}',
    sheet: 'ชีต',
    loading: 'กำลังเปิดไฟล์',
  },
  shared: {
    by: '{{name}} แชร์ให้คุณ',
    until: 'ลิงก์นี้ใช้ได้ถึง {{date}} ไม่ต้องมีบัญชี',
    gone: 'ลิงก์นี้ใช้ไม่ได้แล้ว',
    goneHint: 'ลิงก์อาจหมดอายุหรือถูกยกเลิก ขอลิงก์ใหม่จากคนที่ส่งให้',
    viewOnly: 'ดูได้อย่างเดียว',
  },
} as const

export const en = {
  app: {
    name: 'Drive',
    description:
      'Keep files in your folders, share a folder with people, branches, departments or the whole company, and send outsiders a link',
  },
  nav: { mine: 'My drive', shared: 'Shared with me', recent: 'Recent', starred: 'Starred', trash: 'Trash' },
  roles: { owner: 'Owner', viewer: 'Viewer', uploader: 'Uploader', deleter: 'Deleter', editor: 'Editor' },
  rolesHint: {
    viewer: 'Sees, opens and downloads',
    uploader: 'As a viewer, and uploads, makes subfolders, sends new versions, renames, moves and deletes what they added',
    deleter: "As a viewer, and deletes anyone's (to the trash for 30 days), but uploads nothing",
    editor: "As an uploader and a deleter, and renames or moves anyone's",
  },
  kinds: { user: 'Person', branch: 'Branch', department: 'Department', company: 'Whole company' },
  fileKinds: {
    pdf: 'PDF',
    excel: 'Excel',
    word: 'Word',
    powerpoint: 'PowerPoint',
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    archive: 'Archive',
    text: 'Text',
    other: 'File',
    folder: 'Folder',
  },
  bytes: { b: '{{n}} B', kb: '{{n}} KB', mb: '{{n}} MB', gb: '{{n}} GB' },
  open: 'Open',
  uploadFolder: 'Upload a folder',
  sharedWithList: 'Shared with {{names}}',
  and: ' and ',
  moveHere: 'Move here',
  myRoots: 'My top folders',
  noFolders: 'No folders inside',
  viaYou: 'Shared with you',
  via: 'Shared with {{kind}} {{name}}',
  you: 'You are {{role}}',
  onlyYou: 'Only you',
  room: '{{used}} of {{quota}} used',
  roomTitle: 'My storage',
  root: {
    hint: 'Your drive holds folders only: files always sit in a folder, and a folder here is shared as a whole, everything inside follows it',
    empty: 'No folders yet. Make your first folder to start keeping files',
    sharedHint: 'Folders shared with you, your branch or your department. Open one to see its files',
    sharedEmpty: 'Nobody has shared a folder with you yet',
  },
  columns: {
    name: 'Name',
    owner: 'Owner',
    access: 'Your access',
    sharedAt: 'Shared',
    by: 'Uploaded by',
    updated: 'Last changed',
    size: 'Size',
    where: 'Location',
    trashed: 'Deleted',
  },
  folder: {
    subfolders: 'Folders',
    files: 'Files',
    empty: 'This folder is empty. Drop files here or press upload',
    emptyView: 'This folder is empty',
  },
  actions: {
    new: 'New',
    newFolder: 'New folder',
    newSubfolder: 'New subfolder',
    upload: 'Upload files',
    uploadVersion: 'Upload a new version',
    share: 'Share folder',
    link: 'Outsider link',
    preview: 'Preview',
    download: 'Download',
    rename: 'Rename',
    move: 'Move',
    star: 'Star',
    unstar: 'Remove star',
    details: 'Details',
    trash: 'Delete',
    restore: 'Restore',
    purge: 'Delete forever',
    list: 'List',
    grid: 'Grid',
  },
  newHint: 'Files always sit in a folder: open one to upload',
  folderName: 'Folder name',
  newName: 'New name',
  moveTo: 'Move to',
  moveHint: 'Within the same top folder, or between your own top folders',
  share: {
    title: 'Share folder “{{name}}”',
    add: 'Add a person, branch, department or the whole company',
    people: 'People with access',
    remove: 'Remove access',
    follows: 'Everything in this folder follows these',
    inner: 'Inside the company it follows the folder “{{name}}”',
    setAtTop: 'Set at the folder',
    saved: 'Access saved',
  },
  link: {
    title: 'Outsider link of “{{name}}”',
    label: 'Link for outsiders',
    hint: 'Anyone with the link opens it without an account, until it ends',
    expires: 'Ends',
    days: '{{days}} days ({{date}})',
    download: 'May download',
    copy: 'Copy link',
    copied: 'Link copied',
    make: 'Make a link',
    revoke: 'Turn the link off',
    ownerOnly: "Only the folder's owner makes outsider links",
  },
  details: {
    kind: 'Type',
    size: 'Size',
    where: 'Location',
    by: 'Uploaded by',
    updated: 'Last changed',
    updatedBy: '{{date}} by {{name}}',
    access: 'Who has access',
    versions: 'Versions',
    current: 'Current version',
    version: 'Version {{number}}',
    folder: 'Folder',
  },
  upload: {
    title: 'Uploading {{count}} files',
    done: '{{count}} files uploaded',
    finished: 'Done',
    failed: 'Failed',
    retry: 'Try again',
    drop: 'Drop to upload to “{{name}}”',
    tooLarge: 'Larger than 2 GB',
  },
  trash: {
    hint: 'Things in the trash are deleted for good after 30 days',
    empty: 'The trash is empty',
    purgeConfirm: 'Delete “{{name}}” forever? It cannot come back',
    trashed: 'Moved to the trash',
  },
  recent: { empty: 'No recently changed files' },
  starred: { empty: 'Nothing starred yet' },
  preview: {
    download: 'This file does not open in the web: download it to open on your device',
    page: 'Page {{page}} of {{pages}}',
    sheet: 'Sheet',
    loading: 'Opening the file',
  },
  shared: {
    by: '{{name}} shared this with you',
    until: 'This link works until {{date}}, no account needed',
    gone: 'This link no longer works',
    goneHint: 'It may have ended or been turned off. Ask whoever sent it for a new one',
    viewOnly: 'View only',
  },
} as const
